// AOS Init
window.addEventListener("DOMContentLoaded",()=>{
    setTimeout(()=>{
        AOS.init({
            duration: 1000,
            delay: 100,
            once: true
        })
    },100)
})
import './navigation.js';
import './faq.js';
import './form.js';